<template>
  <div
    ref="wrapperRef"
    class="tooltip-trigger relative inline-block"
    @mouseenter="open"
    @mouseleave="close"
    @focusout="onFocusOut"
  >
    <button
      type="button"
      class="tooltip-trigger-button text-sm bg-gray-300 text-black flex items-center justify-center h-4 w-4 rounded-full cursor-pointer border-0 p-0"
      :aria-label="label"
      :aria-expanded="isOpen"
      aria-haspopup="true"
      :aria-describedby="tooltipId"
      @focus="open"
    >
      <slot name="trigger"> ? </slot>
    </button>
    <div
      :id="tooltipId"
      role="tooltip"
      :aria-hidden="!isOpen"
      tabindex="-1"
      class="tooltip-trigger-panel absolute top-0 right-0 transition-all translate-x-full flex flex-col z-20 p-2 border border-linear-g-primary rounded bg-body-primary shadow text-xs w-48"
      :class="isOpen ? 'visible opacity-100 -right-2' : 'invisible opacity-0'"
    >
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import { uniqueId } from 'lodash-es'
import { onBeforeUnmount, ref } from 'vue'

withDefaults(
  defineProps<{
    label: string
    tooltipId?: string
  }>(),
  {
    tooltipId: () => uniqueId('tooltip-trigger-'),
  },
)

const wrapperRef = ref<HTMLElement | undefined>()
const isOpen = ref<boolean>(false)

function open(): void {
  isOpen.value = true
  document.addEventListener('keydown', onEscape)
}

function close(): void {
  isOpen.value = false
  document.removeEventListener('keydown', onEscape)
}

function onFocusOut(e: FocusEvent): void {
  const wrapper = wrapperRef.value
  if (wrapper && !wrapper.contains(e.relatedTarget as Node)) {
    close()
  }
}

function onEscape(e: KeyboardEvent): void {
  if (e.key === 'Escape') close()
}

onBeforeUnmount(() => {
  document.removeEventListener('keydown', onEscape)
})
</script>
